import React from 'react';
import Link from '@mui/material/Link';
import LocationOnIcon from '@mui/icons-material/LocationOn';

/**
 * Render alamat. Jika terdapat link di dalam tanda kurung, keluarkan teks utama dan
 * tampilkan tautan "Lokasi" dengan ikon yang membuka link pada tab baru.
 */
export const renderAddressWithMapLink = (address: string | undefined | null): React.ReactNode => {
  if (!address) return '';
  // Cari pola: (https://...)
  const match = address.match(/\((https?:\/\/[^\s)]+)\)/i);
  if (match) {
    const url = match[1];
    const main = address.replace(match[0], '').trim();
    return (
      <>
        <span>{main}</span>
        {' '}
        <Link
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{ display: 'inline-flex', alignItems: 'center' }}
        >
          <LocationOnIcon sx={{ mr: 0.5, fontSize: '1rem' }} />
          Lokasi
        </Link>
      </>
    );
  }
  return <span>{address}</span>;
};
